<template>
    <div>
        
    </div>
</template>

<script>
export default {
    data(){
        return{
            value: 'hello vue' 
        }
    }
}
</script>

<style lang="less" scoped>

</style>
